import React from "react";

import { SubSectionPage } from "./sub-section-page";

// will be getting initially 9 stories, but showing only 8 for loadmore functionality
export const CollectionPage = (props) => <SubSectionPage {...props} />;
